import { ContextMenuProvider, EditorPlugin, IEditor } from 'roosterjs-editor-types';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import loc from 'owa-localize';
import { restartList, setNumberingValue } from './ListEdit.locstring.json';
import PluginNames from 'owa-editor-lazy-plugin/lib/utils/PluginNames';
import displaySetNumberingDialog, {
    DisplaySetNumberingDialogInput,
} from './components/ListEdit/displayInsertSetNumberingDialog';
import { DialogResponse } from 'owa-confirm-dialog/lib/actions/DialogResponse';
import setOrderedListNumbering from 'roosterjs-editor-api/lib/format/setOrderedListNumbering';

const LIST_ITEM_TAG_NAME = 'LI';
const ORDERED_LIST_TAG_NAME = 'OL';

export default class ListEdit implements EditorPlugin, ContextMenuProvider<IContextualMenuItem> {
    private editor: IEditor | undefined | null;

    getName() {
        return PluginNames.ListEdit;
    }

    initialize(editor: IEditor) {
        this.editor = editor;
    }

    dispose() {
        this.editor = null;
    }

    getContextMenuItems(node: Node): IContextualMenuItem[] | null {
        let LI = this.editor?.getElementAtCursor(LIST_ITEM_TAG_NAME, node) as HTMLLIElement;

        if (LI) {
            let parentList = this.editor?.getElementAtCursor(
                ORDERED_LIST_TAG_NAME,
                node
            ) as HTMLOListElement;

            if (!parentList || !parentList.isContentEditable) {
                return null;
            }

            return [
                {
                    key: 'resetList',
                    name: loc(restartList),
                    onClick: () => {
                        this.setListNumbering(LI);
                    },
                },
                {
                    key: 'setNumberingValue',
                    name: loc(setNumberingValue),
                    onClick: () => {
                        let startNumber = parentList.start;
                        for (let index = 0; index < parentList.children.length; index++) {
                            if (parentList.children[index] === LI) {
                                break;
                            }
                            startNumber += 1;
                        }

                        this.showSetNumberingDialog(
                            this.editor?.getDocument().defaultView,
                            (value: number) => this.setListNumbering(LI, value),
                            startNumber
                        );
                    },
                },
            ];
        } else {
            return null;
        }
    }

    private setListNumbering = (separator: HTMLLIElement, starNumber: number = 1) => {
        if (this.editor) {
            setOrderedListNumbering(this.editor, separator, starNumber);
        }
    };

    private async showSetNumberingDialog(
        targetWindow: Window | null | undefined,
        onConfirmDialog: (value: number) => void,
        startNumber: number
    ) {
        if (targetWindow) {
            const dialogInput = this.createSetNumberingDialogInput(startNumber);
            const dialogResult = await displaySetNumberingDialog(dialogInput, targetWindow);

            if (DialogResponse.ok === dialogResult) {
                onConfirmDialog(dialogInput.value);
            }
        }
    }

    private createSetNumberingDialogInput(startNumber: number) {
        const result: DisplaySetNumberingDialogInput = {
            value: startNumber,
        };

        return result;
    }
}
